export default __webpack_public_path__ + "static/media/control-skin-nature.d2219d84.png";